// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
// eslint-disable-next-line import/order
import type { NextEditorPluginFunctionOptionalConfigDefinition } from '@atlaskit/editor-common/types';
import { NextEditorPluginAI } from './aiPlugin';
import type { AIPluginDependencies, AIPluginOptions } from './aiPluginType';
import type { EditorPluginAIActions } from './editor-actions/types';
import type { EditorPluginAICommands } from './editor-commands/types';
import type { EditorPluginAISharedState, EditorPluginAIProvider } from './types/types';

const aiPlugin: NextEditorPluginFunctionOptionalConfigDefinition<
	'aiExperience',
	{
		actions: EditorPluginAIActions;
		commands: EditorPluginAICommands;
		dependencies: AIPluginDependencies;
		pluginConfiguration: AIPluginOptions;
		sharedState: EditorPluginAISharedState;
	},
	EditorPluginAIProvider
> = NextEditorPluginAI;
export { aiPlugin };

export type { AIPlugin, AIPluginOptions, AIPluginDependencies } from './aiPluginType';
export type {
	DraftReplyLLMResponsePayload,
	DraftReplyTriggerType,
	EditorPluginAIProvider,
	EditorPluginAISharedState,
} from './types/types';
export type {
	ADFStreamingInfoAEP,
	ADFStreamingErrorAEP,
	EditorAIAnalyticEventPayload,
} from './types/analytics';
export type { EditorPluginAIActions } from './editor-actions/types';
export type { FAILURE_REASON } from './ui/utils/errors';
export type { Field } from './ui/prebuilt/config-items/prompts/draft-reply/draft-reply';
export type { SelectionContext } from './entry-points/editor-common-types';
